const NEWS_FIELDS = Object.freeze([
  { identifier: 'displayCoverPicture', label: s__('Builder|cover picture') },
  { identifier: 'displayTitle', label: s__('Builder|title') },
  { identifier: 'displayCategories', label: s__('Builder|categories') },
  { identifier: 'displayContent', label: s__('Builder|content') },
]);

const EVENTS_FIELDS = Object.freeze([
  { identifier: 'displayAttendees', label: s__('Builder|attendees') },
  { identifier: 'displayCoverPicture', label: s__('Builder|cover picture') },
  { identifier: 'displayTitle', label: s__('Builder|title') },
  { identifier: 'displayCategories', label: s__('Builder|categories') },
  { identifier: 'displayDate', label: s__('Builder|date') },
  { identifier: 'displayLocation', label: s__('Builder|location') },
  { identifier: 'displayOnlineEvent', label: s__('Builder|online event') },
  { identifier: 'displayContent', label: s__('Builder|content') },
]);

const TOPICS_FIELDS = Object.freeze([
  { identifier: 'displayButtons', label: s__('Builder|buttons') },
  { identifier: 'displayCategories', label: s__('Builder|categories') },
  { identifier: 'displayDescription', label: s__('Builder|description') },
  { identifier: 'displayImage', label: s__('Builder|image') },
  { identifier: 'displayTitle', label: s__('Builder|title') },
  { identifier: 'displayLocation', label: s__('Builder|location') },
  {
    identifier: 'displayNumberOfMembers',
    label: s__('Builder|number of members'),
  },
]);

export const FIELD_SETTING_OBJECTS = Object.freeze({
  events: EVENTS_FIELDS,
  news: NEWS_FIELDS,
  topics: TOPICS_FIELDS,
});

export const FIELD_SETTING_PATH = 'attributes.dynamicAttributes.fields';
